import type { ReactNode } from 'react';
import { useMemo, useState } from 'react';

import { ConditionByModal } from '@jane/business-admin/components/shared/specials/modal/conditions/generic_components/ConditionByModal';
import type { Condition } from '@jane/business-admin/components/shared/specials/modal/conditions/generic_components/ConditionByModal';
import type { ConditionType } from '@jane/business-admin/components/shared/specials/modal/form';
import { transformWeightConditions } from '@jane/business-admin/util';
import type { WeightValueCondition } from '@jane/shared/types';

import { WeightValuesModal } from './WeightValuesModal';

export const WeightValuesConditions = ({
  conditions,
  footer,
  onConditionsUpdate,
  type,
}: {
  conditions: WeightValueCondition[];
  footer?: ReactNode;
  onConditionsUpdate: (data: WeightValueCondition[]) => void;
  type: ConditionType.WeightValues | ConditionType.ExcludeWeightValues;
}) => {
  const [modalOpen, setModalOpen] = useState(false);

  const onUpdate = (data: Condition[]) => {
    const dataValues = data.map((condition) => condition.value);
    onConditionsUpdate(dataValues);
  };

  const onSaveModal = (data: WeightValueCondition[]) => {
    onConditionsUpdate(data);
  };

  const parsedConditions = useMemo(() => {
    return transformWeightConditions(conditions);
  }, [conditions]);

  return (
    <>
      <ConditionByModal
        footer={footer}
        onOpenModal={() => setModalOpen(true)}
        type={type}
        conditions={parsedConditions}
        conditionsLoading={false}
        onConditionsUpdate={onUpdate}
      />
      {modalOpen && (
        <WeightValuesModal
          conditions={conditions}
          closeModal={() => setModalOpen(false)}
          onSubmit={onSaveModal}
        />
      )}
    </>
  );
};
